const container = (props) => {
    let { className, ...remainingProps } = props

    className = className ? 
        className + ' container' :
        'container'

    return <div className={className} {...remainingProps} />
}

export default container